export default "__VITE_ASSET__DSwowYB5__"